// ** IMPORTANT **: Keep in sync with functions/src/index.ts RESET_PASSWORD_CALLABLE_ERROR_REASON
export enum RESET_PASSWORD_CALLABLE_ERROR_REASON {
    wrongAuthenticationType = 'wrong-authentication-type',
    missingEmail = 'missing-email',
}
